import { createGlobalStyle } from "styled-components";
export const QueryBuilderStyling = createGlobalStyle `
  .queryBuilder.queryBuilder {
    border: none;
    background-color: ${({ theme }) => theme.colors.expressionBuilderColors.background};
  }

  .queryBuilder.queryBuilder > .ruleGroup {
    padding: ${({ theme }) => `${theme.space[1]}px 0`};
  }

  .ruleGroup.ruleGroup {
      border: none;
      background-color: ${({ theme }) => theme.colors.expressionBuilderColors.background};
    }
  
    .ruleGroup.ruleGroup .ruleGroup-header {
      gap: ${({ theme }) => `${theme.space[2]}px`};
    }
  
    .ruleGroup.ruleGroup .rule {
      padding: 8px 9px 8px 16px;
      display: flex;
      width: 100%;
      box-sizing: border-box;
      border-radius: 3px;
      background-color: ${({ theme }) => theme.colors.expressionBuilderColors.ruleBackground};
    }
  
    .queryBuilder-branches.queryBuilder-branches .rule::before,
    .queryBuilder-branches.queryBuilder-branches .rule::after,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup .ruleGroup::before,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup .ruleGroup::after {
      border-color: ${({ theme }) => theme.colors.expressionBuilderColors.connectingLines};
    }
  
    .queryBuilder-branches.queryBuilder-branches .rule::before,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup .ruleGroup::before {
      border-width: 0 0 2px 2px;
    }
  
    .queryBuilder-branches.queryBuilder-branches .rule::after,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup .ruleGroup::after {
      border-width: 0 0 0 2px;
    }
  
    .queryBuilder-branches.queryBuilder-branches .rule:last-child::before,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup .ruleGroup:last-child::before {
      border-bottom-left-radius: 0px;
    }
  
    /* Fix alignment of "connectingLines" */
    .queryBuilder-branches.queryBuilder-branches .ruleGroup::before,
    .queryBuilder-branches.queryBuilder-branches .ruleGroup::after {
      left: calc(-0.5rem - 1px) !important;
    }
  
    /* 1024 = theme.breakpoints[2] */
    @media (min-width: 1024px) {
      .ruleGroup.ruleGroup .rule {
        width: 75%;
      }
  }
`;
